/**
 * 课程状态枚举
 */
export enum EnumCourseState {
  /** 报名未开始 */
  NotStarted = '报名未开始',
  /** 正在报名 */
  InProgress = '正在报名',
  /** 未开课 */
  NoClass = '未开课',
  /** 开课中 */
  InClass = '开课中',
  /** 已结课 */
  EndofClass = '已结课'
}

export enum EnumNewCourseState {
  /** 报名未开始 */
  NotStarted = '即将报名',
  /** 正在报名 */
  InProgress = '立即报名',
  /** 报名结束 */
  SignupEnd = '报名结束',
  /** 开课中 */
  InClass = '开课中',
  /** 已结课 */
  EndofClass = '已结课'
}

export enum EnumAllCourseState {
  /** 报名未开始 */
  NotStarted = '即将报名',
  /** 正在报名 */
  InProgress = '我要报名',
  /** 未开课 */
  Signuped = '报名结束',
  /** 转报全阶 */
  toAll = '转报全阶',
  /** 开课中 */
  InClass = '开课中',
  /** 已结课 */
  EndofClass = '已结课'
}

export enum EnumHotCourseStyle {
  /** 报名未开始 */
  NotStarted = '-red-no',
  /** 正在报名 */
  InProgress = '-red',
  /** 未开课 */
  Signuped = '-red-no',
  /** 转报全阶 */
  toAll = '-red',
  /** 开课中 */
  InClass = '-yellow',
  /** 已结课 */
  EndofClass = '-black'
}

/**
 * 日课报名
 * **/
export enum EnumDayCourseState {
  /** 报名未开始 */
  NotStarted = '报名未开始',
  /** 正在报名 */
  InProgress = '正在报名',
  endSignup = '报名结束'
}
export enum EnumCourseSignupType {
  /** 自己购买 */
  Purchase = 'Purchase',
  /** 赠送 */
  Give = 'Give',
  /** 礼物 */
  Gift = 'Gift',
  /** 活动进度 */
  Progress = 'Progress',
  /** 团购购买 **/
  groupBuy = 'groupBuy',
  /** 去上课 */
  GoCourse = 'GoCourse'
}
/** 课程状态（1未发布，2已发布，3已下架） */
export enum EnumCoursePublishStatus {
  /** 未发布 */
  Unpublished = 1,
  /** 已发布 */
  Published = 2,
  /** 已下架 */
  Offtheshelf = 3
}
/** 课程类型 */
export enum EnumCourseType {
  /** 单 */
  single = 1,
  /** 全 */
  full = 2
}

/**
 * 课时状态枚举
 */
export enum EnumClasshour {}

export enum EnumClasshourStatus {
  /**
   * 未发布
   *
   * 5月16日 文字置灰 底图置灰
   */
  Unpublish,
  /**
   * 回放结束
   *
   * 结束啦 文字置灰
   */
  PlaybackEnd,
  /**
   * 回放有效期中
   *
   * 回放剩余6小时 天 > 小时 > 分钟
   */
  Playback,
  /**
   * 已发布，直播未开始
   *
   * 距开课还有12天 天 > 小时 > 分钟
   */
  WillLive,
  /**
   * 学习回顾卡
   *
   * 回顾剩余6小时 天 > 小时 > 分钟
   */
  StudyBuff,
  /**
   * 直播中
   *
   * 直播中...
   */
  Living,
  /**
   * 直播结束
   *
   * 直播结束
   */
  LiveEnd
}

/** 课程上课频率 新同学请了解弹窗使用 */
export enum EnumLearnFreqType {
  /**
   * 当周周六
   */
  THE_WEEK_SATURDAY = 11,
  /**
   * 当周周日
   */
  THE_WEEK_SUNDAY = 12,
  /**
   * 隔周周六
   */
  EVERY_OTHER_WEEK_SATURDAY = 21,
  /**
   * 隔周周日
   */
  EVERY_OTHER_WEEK_SUNDAY = 22
}

export enum EnumStudyCardType {
  /**
   * 课时最长观看
   */
  MaxLessonWatch = 1,
  /**
   * 完成直播观看
   */
  CompleteLiveWatch = 2,
  /**
   * 最早提交作业
   */
  EarliestHomeworkSubmit = 3,
  /**
   * 最晚提交作业
   */
  LatestHomeworkSubmit = 4,
  /**
   * 字数最多作业
   */
  MaxWordsHomework = 5,
  /**
   * 助教互动
   */
  MaxInteraction = 6,
  /**
   * 连续提交
   */
  ContinuousSubmit = 7,
  /**
   * 评论最多
   */
  MaxComments = 8,
  /**
   * 点赞最多
   */
  MaxLikes = 9,
  /**
   * 收藏最多
   */
  MaxCollects = 10,
  /**
   * 指定时间内完成学习
   */
  CompleteStudyInTime = 11,
  /**
   * 评论互动最多
   */
  MaxCommentInteractions = 12,
  /**
   * 点赞互动最多
   */
  MaxLikeInteractions = 13,
  /**
   * 被点赞互动最多
   */
  MaxBeLikedInteractions = 14,
  /**
   * 收藏互动最多
   */
  MaxCollectInteractions = 15,
  /**
   * 学习时长最长
   */
  MaxStudyDuration = 16,
  /**
   * 不间断观看课程
   */
  UninterruptedCourseWatch = 17,
  /**
   * 不间断提交日常
   */
  UninterruptedDailySubmit = 18
}
